<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12 md6 sm8>
          <v-card class="mx-auto" style="border: 1px inset teal;">
            <v-toolbar color="teal" dark>
              <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->
              <v-toolbar-title>Notifications</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="viewGrouped = !viewGrouped">
                <v-icon>{{ viewGrouped ? 'mdi-dots-vertical' : 'mdi-format-list-bulleted-type'  }}</v-icon>
              </v-btn>
            </v-toolbar>
            <transition-group name="custom-classes-transition" enter-active-class="animate__animated animate__fadeIn" leave-active-class="animate__animated animate__fadeOut" mode="in-out">
              <v-list v-show="viewGrouped" key="grouped">
                <v-list-group v-for="(group, key) in grouped" :key="group.length + Math.random()" no-action>
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title v-text="n_title(key)"></v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <notification-view v-for="notification in group" :key="notification.id" :notification="notification" :show_title="false"></notification-view>
                </v-list-group>
              </v-list>
              <v-list v-show="!viewGrouped" key="all" class="py-0">
                <notification-view v-for="notification in user_notifications" :key="notification.id" :notification="notification"></notification-view>
              </v-list>
            </transition-group>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/User'
  const NotificationView = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "notifications" */ '@/Components/components/Notifications/notification')

  export default {
    name: 'UserNotification',
    layout,
    props: [
      'user_notifications',
      'open_type'
    ],
    components: {
      NotificationView,
    },
    metaInfo () {
      return {
        title: 'Notifications',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        viewGrouped: this.open_type == 'group',
      }
    },
    methods: {
      n_title (title) {
        let type = title;
        if (!type) {
          return ''
        }
        let titleText = type.replace('App\\Notifications\\', '')
        return titleText.toTitleCase()
      }
    },
    computed: {
      grouped () {
        return _.groupBy(this.user_notifications, 'type')
      }
    },
    watch: {
      'open_type': function (val) {
        if (val == 'group') {
          this.viewGrouped = true;
        } else {
          this.viewGrouped = false
        }
      },
    }
  }
</script>

<style>
   /**/
</style>
